export * from './lead-score-badge/lead-score-badge.component';
